import React, { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import ContactStack from "../ContactPage/ContactPage";
import ClientSection from '../About/ClientSection/ClientSection';

import Testimonials from "../Testimonials/Testimonials";
import "./Team.css";


const Team = () => {
    const [showContact, setShowContact] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <div className="team-page-wrapper">
            <Navbar />


                    <ClientSection />
                  
                    <Testimonials/>
              
            <Footer onContactClick={() => setShowContact(true)} />

            <AnimatePresence>
                {showContact && (
                    <ContactStack onClose={() => setShowContact(false)} />
                )}
            </AnimatePresence>

        </div>
    );
};

export default Team;
